export const START_TIMER = '@types/start-timer';
export const STOP_TIMER = '@types/stop-timer';

/**
 * Redux action for the DigitalDispatch timer reducer;
 * this triggers the timer to start after a successful
 * batch of dispatch offers
 * @param {number} dispatchId
 * @returns {function}
 */
export function startDigitalDispatchTimer(dispatchId, timerDuration = 120) {
  return (dispatch) => {
    dispatch({
      type: START_TIMER,
      payload: {
        dispatchId,
        timerDuration
      }
    });
  };
}

/**
 * Redux action for the DigitalDispatch timer reducer;
 * this stops the timer to if a dispatch update comes
 * in for that particular dispatch (In DigitalDispatch a provider
 * "accept" is conveyed by a first 'New'/'Dispatched' status coming in)
 * @returns {function}
 */
export function stopDigitalDispatchTimer() {
  return (dispatch) => {
    dispatch({
      type: STOP_TIMER,
    });
  };
}
